module.exports = __webpack_public_path__ + "img/vizibillLogo.65796074.png";